import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import Button from "../../ui/Button"
import Form from "./Form"
import DateCard from "./DateCard"
import FormPassengersCard from "./FormPassengersCard"
import AdditionalOptionsCard from "./AdditionalOptionsCard"
import { DEPARTURE_DIRECTION, RETURN_DIRECTION } from "../../../utils/variables/common"
import CurrencySelector from "../../CurrencySelector"

const Panel = ({
  departureTerminals,
  arrivalTerminals,
  isLoading,
  isLoadingTo,
  selectedFrom,
  selectedTo,
  dates,
  passengers,
  isRoundTrip,
  onSearch,
  onFetchDefault,
  onSelect,
  onSwap,
  onClear,
  onDatesChange,
  onPassengersChange,
  onSubmit,
  locale,
  nationalities = [],
  contents,
  availableDepart,
  availableRetur,
  departPriceData,
  returPriceData,
  onCalendarMonthChange,
  currency,
  currencies,
  onCurrencyChange,
}) => {
  const { t } = useTranslation()
  const [openCalendar, setOpenCalendar] = useState(null)

  const handleCalendar = (type) => {
    setOpenCalendar((prev) => (prev === type ? null : type))
  }

  return (
    <div className="bg-app-content-subtle/10 w-full flex flex-col gap-4 rounded-b-input rounded-tl-input p-3 relative">
      <div className="flex  pb-4 sm:pb-0 flex-col xl:flex-row gap-10 xl:gap-5 xl:items-center">
        <Form
          departureTerminals={departureTerminals}
          arrivalTerminals={arrivalTerminals}
          selectedFrom={selectedFrom}
          selectedTo={selectedTo}
          isLoading={isLoading}
          isLoadingTo={isLoadingTo}
          onSearch={onSearch}
          onFetchDefault={onFetchDefault}
          onSelect={onSelect}
          onSwap={onSwap}
          onClear={onClear}
          contents={contents}
        />

        <div className="flex flex-col sm:flex-row gap-4 xl:items-center xl:flex-1">
          <DateCard
            isDeparture
            dates={dates}
            onDatesChange={onDatesChange}
            handleModal={() => handleCalendar(DEPARTURE_DIRECTION)}
            isOpenCalendar={openCalendar === DEPARTURE_DIRECTION}
            availableDepart={availableDepart}
            availableRetur={availableRetur}
            departPriceData={departPriceData}
            returPriceData={returPriceData}
            onCalendarMonthChange={onCalendarMonthChange}
            currency={currency}
            currencies={currencies}
            onCurrencyChange={onCurrencyChange}
          />
          <DateCard
            dates={dates}
            onDatesChange={onDatesChange}
            handleModal={() => handleCalendar(RETURN_DIRECTION)}
            isOpenCalendar={openCalendar === RETURN_DIRECTION}
            availableDepart={availableDepart}
            availableRetur={availableRetur}
            departPriceData={departPriceData}
            returPriceData={returPriceData}
            onCalendarMonthChange={onCalendarMonthChange}
            currency={currency}
            currencies={currencies}
            onCurrencyChange={onCurrencyChange}
          />
          <FormPassengersCard
            passengers={passengers}
            onPassengersChange={onPassengersChange}
            currency={currency}
            currencies={currencies}
            onCurrencyChange={onCurrencyChange}
          />
        </div>

        <Button
          className="hidden sm:block w-full xl:w-auto"
          size="lg"
          onClick={onSubmit}
          disabled={!selectedFrom || !selectedTo || !dates.depart[0]}
        >
          {t("filter.find")}
        </Button>
      </div>

      <div className="flex items-center sm:flex-row flex-col gap-3">
        {/* <AdditionalOptionsCard nationalities={nationalities} /> */}
        <Button
          className="sm:hidden w-full flex-1"
          size="lg"
          onClick={onSubmit}
          disabled={!selectedFrom || !selectedTo || !dates.depart[0]}
        >
          {t("filter.find")}
        </Button>
      </div>
    </div>
  )
}

export default Panel
